export default {
  GET_DICT: 'GET_DICT',
  GET_CACD: 'GET_CACD',
  GET_BASEADCD: 'GET_BASEADCD',
  GET_BASEUSERADCD: 'GET_BASEUSERADCD'
}
